import React from "react";
import { useState, useEffect, useRef } from "react";

// On importe les éléments spécifique au web et au mobile
import ComponentProps from "../../../specific/utils/Interfaces/ComponentProps";
import * as Navigation from "../../../specific/utils/Navigation/Navigation";
import Main from "../../../specific/components/Main/Main";

import {
    View,
    Platform,
    Linking,
    Animated,
    EmitterSubscription,
    Image,
    Text
} from 'react-native';

import AppTheme from "../../utils/Theme";
import * as Constants from "../../utils/Constants";
import MainOptions from "../../models/MainOptions";

// Assets
import Images from "../../../specific/utils/Images";

// Services
import { signOut } from "../../services/Auth";

// Utils
import Alert from "../Notification/Alert";
import * as DateUtils from "../../utils/DateUtils";

import { EventRegister } from "../../utils/EventListeners";

import User from "../../data/user/User";

import { initInAppPurchaseSDK } from "../../../specific/services/InAppPurchase/InAppPurchaseService";
import { initAnalyticsServices, initUserIdForAnalytics, revokeAnalyticsServices, setUserProperty } from "../../services/Tracking/Analytics";

import { useLocation, useNavigate } from "../../../specific/utils/Navigation/Navigation";
import { buildLocalDB, getLocalActivities, getLocalCategories, getLocalDocs, getLocalGameImages, getLocalGameLabels, getLocalintegrationSteps, getLocalMenuSettings, getLocalNews, getLocalSuperPowers, getLocalTips } from "../../../specific/utils/LocalStorage";
import { requestTrackingTransparencyStatus } from "../../services/Tracking/TrackingTransparency";
import { handleUrl } from "../../../specific/utils/Deeplink/Deeplink";
import { playSound } from "../../../specific/utils/AudioPlayer/SimpleSoundPlayer";
import { revokeDBListeners, launchUserListener, activitiesListener, categoriesListener, checkVersionUpgrade, gameLabelListener, launchStepsListener, updateActions, userActionsListener, launchNewsListener, gameImagesListener, docsListener, superPowersListener, tipsListener, getUserWithId, getUserActions, checkUserDd } from "../../services/Firebase/Database";
import { revokeSoundPlayerSubscriptions } from "../../../specific/utils/AudioPlayer/SimpleSoundPlayerService";

// Data
import { relaunchLostDownloads } from "../../../specific/components/Download/DownloadButton";
import Style from "../../utils/Style";
import Footer from "../../designSystem/Footer/Footer";
import ActivityIndicator from "../../designSystem/ActivityIndicator/ActivityIndicator";
import Divider from "../../designSystem/Divider/Divider";
import DeepLink from "../../services/DeepLink/DeepLink";
import { AppTarget, getAppTarget } from "../../../specific/utils/Navigation/Host";
import { fetchOIDCAuthToken, startAuth } from "../../../specific/components/Authentication/TNE/Auth";

import { build } from "../../../../package.json";

import { sha256 } from 'js-sha256';
import { AsyncStorageKey, getItemFromAsyncStorage, setItemToAsyncStorage } from "../../utils/AsyncStorage/AsyncStorage";

let isUserConnected = false;

export const logoutUser = () => {
    isUserConnected = false;
}

interface SplashscreenProps extends ComponentProps {

}

const Splashscreen = (props: SplashscreenProps) => {

    const appTheme: AppTheme = new AppTheme();

    // PROPS
    const { componentId = "" } = props;

    let navigate: any = null;
    let location: any = null;
    if (Platform.OS === "web") {
        navigate = useNavigate();
        location = useLocation();
    }

    // Animation
    const [isAnimationOver, setIsAnimationOver] = useState<boolean>(false);
    const [fadeAnim] = useState(new Animated.Value(0));
    const [mvmtAnim] = useState(new Animated.Value(appTheme.pixelPerfect(-40)));
    const [fadeFinalDisappearAnim] = useState(new Animated.Value(1));
    const [fadeFinalAppearAnim] = useState(new Animated.Value(0));

    const images: Images = new Images();
    const user: User = User.getInstance();
    const alertRef = useRef<Alert>(null);

    const onViewDidAppear = () => {
        console.log("WHAAT")
        startAppFromScratch();
    }

    const startAppFromScratch = () => {
        // Si on est en GAR, on redirige vers la page de connexion
        if (Platform.OS === "web") {
            const appTarget: AppTarget = getAppTarget();
            if (appTarget === "gar-preprod") {
                // On va se connecter au GAR
                const deepLink: DeepLink = DeepLink.getInstance();
                if (Platform.OS === "web") {
                    if (window.location.href.indexOf("/openid") !== -1) {
                        // On va récupérer le code
                        const deeplinkUrl: URL = new URL(window.location.href);
                        const linkCode: string = deeplinkUrl.searchParams.get("code");
                        const linkState: string = deeplinkUrl.searchParams.get("state");
                        const linkNonce: string = deeplinkUrl.searchParams.get("nonce");
                        const sessionNonce: string = sessionStorage.getItem("nonce");
                        const sessionState: string = sessionStorage.getItem("state");
                        if ((sha256(sessionNonce) === linkNonce) && (sessionState === linkState)) {
                            sessionStorage.setItem("code", linkCode);
                            fetchOIDCAuthToken();
                        }
                    } else {
                        startAuth();
                    }
                } else {
                    startAuth();
                }
            } else {
                if (isAnimationOver === false) {
                    launchSplashcreenAnimation();
                }
            }
        } else {
            //initAuth();
            if (isAnimationOver === false) {
                launchSplashcreenAnimation();
            }
        }
    }

    useEffect(() => {
        if (isAnimationOver === true) {
            launchAppCheck()
        }
    }, [isAnimationOver]);

    useEffect(() => {
        // Universal Links
        let linkingSubscription: EmitterSubscription | undefined = undefined;
        if (Platform.OS !== "web") {
            linkingSubscription = Linking.addEventListener('url', (event) => {
                if (event.url.includes("//oauthredirect/openid/") === true) {
                    EventRegister.emitEvent(Constants.EventOIDCCallback, { url: event.url });
                } else {
                    if (isUserConnected === true) {
                        handleUrl({ url: event.url, isLaunchedUrl: false, componentId, navigate });
                    } else {
                        const deepLink: DeepLink = DeepLink.getInstance();
                        deepLink.path = event.url;
                    }
                }
            });
        }
        EventRegister.addEventListener(Constants.EventGRPDConsentDone, () => {
            setTimeout(() => {
                checkGpdrConsent();
            }, 1500);
        });
        EventRegister.addEventListener(Constants.EventRelaunchApp, () => {
            setTimeout(() => {
                launchAppCheck();
            }, 1500);
        });
        EventRegister.addEventListener(Constants.EventNotificationChoiceDone, (userData) => {
            setTimeout(() => {
                launchApp();
            }, 1500);
        });
        return () => {
            if (isAnimationOver === true) {
                revokeSoundPlayerSubscriptions();
                revokeAnalyticsServices();
                revokeDBListeners();
                EventRegister.removeEventListener(Constants.EventUserAuthDB);
                if (Platform.OS !== "web") {
                    if (linkingSubscription !== undefined) {
                        Linking.removeSubscription(linkingSubscription);
                    }
                }
            }
        };
    }, []);

    const launchAppCheck = async () => {
        checkUserConnexion();
    }

    const checkUpgradeNotification = async () => {
        if (Platform.OS !== "web") {
            const versionNeedUpgrade = await checkVersionUpgrade();
            const { updateUpgradeRequest, details } = versionNeedUpgrade;
            if (updateUpgradeRequest === true) {
                if (details.force === true) {
                    alertRef.current?.showAlert({
                        title: details.updateTitle,
                        body: details.updateMsg,
                        primaryButtonTitle: "Mettre à jour",
                        onPressPrimaryButton: updateTheAppNow,
                        hideTheAlertOnOptionPressed: false
                    });
                } else {
                    alertRef.current?.showAlert({
                        title: details.updateTitle,
                        body: details.updateMsg,
                        primaryButtonTitle: "Mettre à jour",
                        onPressPrimaryButton: updateTheAppNow,
                        secondaryButtonTitle: "Plus tard",
                        onPressSecondaryButton: updateTheAppLater
                    });
                }
            }
        }
    }

    const updateTheAppNow = async () => {
        const canOpenTheUrl = await Linking.canOpenURL(Constants.appUrl);
        if (canOpenTheUrl === true) {
            Linking.openURL(Constants.appUrl);
        }
    }

    const updateTheAppLater = () => {
        setItemToAsyncStorage({ itemKey: AsyncStorageKey.upgrade, item: { version: build, ignored: true, date: new Date().getTime() } });
    }

    const checkGpdrConsent = async () => {
        try {
            const gdprConsentValue = await getItemFromAsyncStorage({ itemKey: AsyncStorageKey.gdprConsent });
            if (gdprConsentValue === null) {
                launchGdprConsent();
            } else {
                const gdprData = gdprConsentValue.data;
                const now = new Date().getTime();
                const numberOfMonth = DateUtils.monthDiff(now, gdprData.ts);
                if (numberOfMonth > 12) {
                    // Cela fait plus de 13 mois que nous avons demandé le consentement, il faut recommencer.
                    launchGdprConsent();
                } else {
                    gpdrConsentValidated();
                    initAnalyticsServices();
                    if (Platform.OS === "ios") {
                        // Nous allons demander l'autorisation d'utiliser l'IDFA
                        await requestTrackingTransparencyStatus();
                    }
                }
            }
        } catch (error) {
            launchGdprConsent();
        }
    }

    const launchGdprConsent = () => {
        Navigation.showModalInView({
            componentId,
            name: Constants.ScreenConsentNotification,
            options: {
                modalPresentationStyle: 'overCurrentContext',
                layout: {
                    componentBackgroundColor: 'transparent'
                }
            }
        });
    }

    const checkUserConnexion = async () => {
        if ((user.currentUser !== null) && (user.currentUser.uid !== undefined)) {
            const userAuthData = user.currentUser;
            isUserConnected = true;
            initUserIdForAnalytics(userAuthData.uid);
            await user.setAuthUserData(userAuthData);
            EventRegister.emit(Constants.EventUserAuthDB, userAuthData);
            // On va transmettre les informations de l'utilisateur
            const offlineUserData = await user.initUserData(userAuthData);
            if (offlineUserData === undefined) {
                await signOut();
                checkUserConnexion();
            } else {
                const dbUserData = await getUserData(userAuthData);
                if (dbUserData === undefined) {
                    await signOut();
                    checkUserConnexion();
                } else {
                    if ((user.tne_ido !== undefined) && (user.tne_ido.length > 0)) {
                        gpdrConsentValidated();
                    } else {
                        checkGpdrConsent();
                    }
                }
            }
        } else {
            isUserConnected = false;
            launchAuthLanding();
        }
    }

    const gpdrConsentValidated = async () => {
        // On va vérifier la dernière version de l'utilisateur, et la mettre à jour si nécessaire
        const userAuthData = user.currentUser;
        const offlineUserData = await user.initUserData(userAuthData);
        const dbUserData = await getUserData(userAuthData);
        checkUserDd({ user_id: userAuthData.uid, dbUserData });
        if (Platform.OS !== "web") {
            getAppData();
            relaunchLostDownloads();
        } else {
            getWebAppData();
        }
        if (Platform.OS !== "web") {
            initInAppPurchaseSDK();
        }
        await user.getUserSubForRC();
        enterAppOnceConnected(offlineUserData);
        checkUpgradeNotification();
    }

    const enterAppOnceConnected = (offlineUserData) => {
        // On va regarder si l'URL est splaschreen ou deeplink
        if (Platform.OS === "web") {
            if (location.pathname.indexOf("deeplink") !== -1) {
                let urlToNavigate = location.pathname.replace("/deeplink/", "");
                navigate(decodeURIComponent(urlToNavigate), { state: "deeplink" });
            } else {
                launchApp();
            }
        } else {
            launchApp();
        }
    }

    const getWebAppData = async () => {
        await getLocalActivities();
        await getLocalTips();
        await getLocalNews();
        launchNewsListener();
        await getLocalDocs();
        docsListener();
    }

    const getAppData = async () => {
        const localActivities = await getLocalActivities();
        activitiesListener();
        await getLocalMenuSettings();
        await getLocalCategories();
        categoriesListener();
        await getLocalGameImages();
        gameImagesListener();
        await getLocalGameLabels();
        gameLabelListener();
        await getLocalintegrationSteps();
        launchStepsListener();
        await getLocalNews();
        launchNewsListener();
        await getLocalDocs();
        docsListener();
        await getLocalSuperPowers();
        superPowersListener();
        await getLocalTips();
        tipsListener();
        buildLocalDB(localActivities.data);
    }

    const getUserData = async (userAuthData: { email: string | null | undefined, uid: string | undefined } | null) => {
        try {
            // On récupère les informations du profil utilisateur
            const userData = await getUserWithId({ user_id: userAuthData?.uid });
            if (userData === undefined) {
                return undefined;
            }
            await user.setDBUserData(userData);
            const userProfileForAnalytics = user.getUserProfileForAnalytics();
            if ((userProfileForAnalytics !== undefined) && (userProfileForAnalytics !== null)) {
                setUserProperty({ key: "profile", value: userProfileForAnalytics });
            }
            // On va regarder si l'utilisateur est premium
            const userSubStatusForAnalytics = user.getUserSubscriptionStatusForAnalytics();
            if (userSubStatusForAnalytics.code !== undefined) {
                setUserProperty({ key: "subscription_code", value: userSubStatusForAnalytics.code });
            }
            setUserProperty({ key: "subscription_status", value: userSubStatusForAnalytics.subStatus });
            setUserProperty({ key: "subscription_end_date", value: userSubStatusForAnalytics.endDate });
            EventRegister.emit(Constants.EventUserAuthDB, userData);
            // On récupère les informaitons de gamification
            let userActions = await getUserActions({ user_id: userAuthData.uid });
            if (userActions !== undefined) {
                // On va regarder si l'utilisateur gagne un jour de plus
                const today = new Date().getTime();
                let lastConnexionDate = DateUtils.getNumericDateAsIntForTimestamp(today);
                let daysInARow = userActions.days_in_a_row !== undefined ? parseInt(userActions.days_in_a_row) : 1;
                let rewards = [];
                let pts = userActions.pts;
                if (userActions.last_connexion_date !== undefined) {
                    const lastDay = parseInt(userActions.last_connexion_date);
                    const diffBetweenConnexion = lastConnexionDate - lastDay;
                    if (diffBetweenConnexion === 1) {
                        daysInARow = daysInARow + 1;
                        const dayPts = daysInARow > 2 ? 30 : 10;
                        rewards.push({
                            type: 'modal',
                            action: 'days_in_a_row',
                            number: daysInARow,
                            pts: dayPts
                        });
                        pts = pts + dayPts;
                    } else if (diffBetweenConnexion > 1) {
                        daysInARow = 1;
                    }
                }
                await updateActions({ pts, last_connexion_date: lastConnexionDate, days_in_a_row: daysInARow });
                userActions.days_in_a_row = daysInARow;
                userActions.last_connexion_date = lastConnexionDate;
                userActions.pts = pts;
                await user.setActionsUserData(userActions);
                EventRegister.emit(Constants.EventUserAuthDB, userData);
                userActionsListener({ user_id: userAuthData?.uid });
            }
            launchUserListener({ user_id: userAuthData.uid });
            return userData;
        } catch (error) {
            throw (error);
        }
    }

    const launchApp = async () => {
        const initialUrl: string | null = await Linking.getInitialURL();
        if (initialUrl !== null) {
            const deepLink: DeepLink = DeepLink.getInstance();
            deepLink.path = initialUrl;
        }
        Navigation.showModal({
            componentId,
            navigate,
            name: Constants.ScreenAppMenu
        });
    }

    const launchAuthLanding = () => {
        Navigation.showModal({
            componentId,
            navigate,
            name: Constants.ScreenAuthLanding
        });
    }

    // MainOptions
    const mainOptions: MainOptions = new MainOptions({
        key: "splashscreen",
        componentId,
        showNavBar: false,
        showMenu: false,
        canGoBack: false,
        safeArea: false,
        forceFullWidth: true
    });

    const topPosition = (appTheme.getFullAppHeight() - appTheme.pixelPerfect(67)) / 2;
    const center = (appTheme.getFullScreenWidth() - appTheme.pixelPerfect(121)) / 2;
    const launchSplashcreenAnimation = () => {
        playSound("lili_bienvenue.mp3", "app", true);
        Animated.parallel([
            Animated.timing(fadeAnim, {
                toValue: 1,
                duration: 1000,
                useNativeDriver: false
            }),
            Animated.timing(mvmtAnim, {
                toValue: center,
                duration: 1000,
                useNativeDriver: false
            })
        ]).start(() => {
            Animated.timing(fadeAnim, {
                toValue: 0,
                duration: 1000,
                useNativeDriver: false
            }).start(() => {
            });
            Animated.timing(fadeFinalAppearAnim, {
                toValue: 1,
                duration: 1000,
                useNativeDriver: false
            }).start(() => {
            });
            Animated.timing(fadeFinalDisappearAnim, {
                toValue: 0,
                duration: 1000,
                useNativeDriver: false
            }).start((event) => {
                if (event.finished === true) {
                    setTimeout(() => {
                        setIsAnimationOver(true);
                    }, 1000);
                }
            });
        });
    };

    const getContentView = () => {
        console.log({isAnimationOver})
        if (isAnimationOver === false) {
            return <View onLayout={onViewDidAppear} style={{ width: appTheme.getFullScreenWidth(), height: appTheme.getFullScreenHeight(), backgroundColor: appTheme.still, justifyContent: "center", alignItems: "center" }}>
                <Animated.Image source={images.icCloud} style={{ left: mvmtAnim, position: "absolute", top: topPosition, width: appTheme.pixelPerfect(121), height: appTheme.pixelPerfect(67), opacity: fadeAnim }} resizeMode="contain" />
                <Animated.Image source={images.icTalkEyes} style={{ position: "absolute", top: topPosition, width: appTheme.pixelPerfect(121), height: appTheme.pixelPerfect(67), opacity: fadeFinalDisappearAnim }} resizeMode="contain" />
                <Animated.Image source={images.icTalk} style={{ left: center, position: "absolute", top: topPosition, width: appTheme.pixelPerfect(121), height: appTheme.pixelPerfect(67), opacity: fadeFinalAppearAnim }} resizeMode="contain" />
                <Animated.Text style={{ position: "absolute", top: topPosition + appTheme.pixelPerfect(30), left: center - appTheme.pixelPerfect(6), letterSpacing: appTheme.pixelPerfectForFont(2), fontFamily: appTheme.primaryMediumFont, fontSize: appTheme.pixelPerfectForFont(56), opacity: fadeFinalDisappearAnim }}>LILI</Animated.Text>
            </View>
        }
        return <View style={[Style.shadowed, { width: appTheme.getFullScreenWidth(), height: appTheme.getFullScreenHeight(), backgroundColor: appTheme.still, justifyContent: "center", alignItems: "center" }]}>
            <View style={{ left: center, position: "absolute", top: topPosition }}>
                <Image
                    source={images.icTalk}
                    style={{ width: appTheme.pixelPerfect(121), height: appTheme.pixelPerfect(67), opacity: 1 }}
                    resizeMode="contain" />
                <Divider />
                <ActivityIndicator loading={true} />
            </View>
            <Footer />
        </View>
    }

    return (
        <Main mainOptions={mainOptions} >
            {getContentView()}
            <Alert ref={alertRef} />
        </Main>
    )
}

export default Splashscreen;